import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import { connect } from 'react-redux';

import CSS from './styles.css';
import { createNote } from 'PipeRouter';


const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

class NoteEditor extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount = () => {
    const { highlight } = this.props;
    const rows = this.countTextareaRows(highlight.noteText);

    this.setState({
      editRows: rows,
      initRows: rows,
      isSaveDisabled: true,
      noteText: this.props.highlight.noteText
    });
  };

  componentWillReceiveProps = nextProps => {
    const { highlight } = nextProps;
    const { noteText } = this.state;

    if (highlight.noteText !== noteText) {
      this.setState({
        noteText: highlight.noteText,
        initRows: this.countTextareaRows(highlight.noteText),
        editRows: this.countTextareaRows(highlight.noteText)
      });
    }
  };

  onKeyDown = event => {
    const { keyCode, target } = event;
    const textContent = target.textContent;

    if (keyCode === keys.enter || keyCode === keys.space) {
      if (textContent === 'Cancel') {
        this.cancelEdit(event);
        event.preventDefault();
      }

      if (textContent === 'Save') {
        this.saveNote(event);
        event.preventDefault();
      }
    }

  };

  countTextareaRows = noteText => {
    let rows = 1;

    if (noteText.match(/\n/g)) {
      rows = noteText.match(/\n/g).length + 1;
    }

    return rows;
  };

  handleOnChange = event => {
    const newText = event.target.value;
    const { isSaveDisabled } = this.state;

    this.setState({
      noteText: newText,
      isSaveDisabled: false
    });
  };

  handleOnKeyDown = event => {
    if (event.keyCode === 13) {
      const { editRows } = this.state;
      event.target.parentElement.querySelector('textarea').setAttribute('rows', editRows + 1);
      this.setState({ editRows: editRows + 1 });
    }
  };

  cancelEdit = event => {
    const { cancelEdit:parentCancelEdit, highlight } = this.props;
    const { initRows } = this.state;
    let highlightId = '';

    if (event.keyCode) {
      highlightId = event.target.id.split('#')[1];
    }

    this.setState({
      editRows: initRows,
      noteText: highlight.noteText,
      isSaveDisabled: true
    }, () => {
      parentCancelEdit(highlightId);
    });
  };

  saveNote = event => {
    const { createNote, saveNote:parentSaveNote, highlight } = this.props;
    const { noteText } = this.state;
    const rows = this.countTextareaRows(noteText);
    const selectedHighlight = {
      id: highlight.id,
      markerId: highlight.markerId,
      noteText
    };
    let highlightId;

    if (event.keyCode) {
      highlightId = highlight.id;
    }

    if (highlight.noteText !== noteText) {
      createNote(selectedHighlight);
    }

    this.props.highlight.noteText = noteText;
    this.setState({
      editRows: rows,
      initRows: rows,
      isSaveDisabled: true
    }, () => {
      parentSaveNote(highlightId);
    });
  };

  render() {
    const { isEditingNote, cancelEdit, highlight, saveNote } = this.props;
    const { editRows, initRows, isSaveDisabled, noteText } = this.state;

    if (!isEditingNote) {
      return (
        <section className={ CSS['note'] }>
          <textarea rows={ initRows } value={ highlight.noteText } tabIndex="0" readOnly/>
        </section>
      );
    }

    const editingNote = `${CSS['note']} ${CSS['editing_note']}`;
    return (
      <section className={ editingNote }>
        <textarea id={ `highlightId#${highlight.id}` } rows={ editRows } value={ noteText } onChange={ this.handleOnChange } onKeyDown={ this.handleOnKeyDown } tabIndex="0" autoFocus/>
        <div className={ CSS['actions'] }>
          <button className={ CSS['save'] } onClick={ this.saveNote } onKeyDown={ this.onKeyDown } disabled={ isSaveDisabled } tabIndex="0">
            Save
          </button>
          <button id={ `cancel#${highlight.id}`} className={ CSS['cancel'] } onClick={ this.cancelEdit } onKeyDown={ this.onKeyDown } tabIndex="0">
            Cancel
          </button>
      </div>
      </section>
    );
  }
}

NoteEditor.defaultProps = {};

NoteEditor.propTypes = {
  isEditingNote: bool,
  cancelEdit: func,
  handleOnChange: func,
  handleOnKeyDown: func,
  highlight: object,
  saveNote: func
};


export default connect(null, {
  createNote
})(NoteEditor);
